module.exports = __webpack_public_path__ + "static/media/light.e765f4e4.svg";